import { render, staticRenderFns } from "./FlatLoader.vue?vue&type=template&id=0e883794&scoped=true"
import script from "./FlatLoader.vue?vue&type=script&lang=ts"
export * from "./FlatLoader.vue?vue&type=script&lang=ts"
import style0 from "./FlatLoader.vue?vue&type=style&index=0&id=0e883794&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e883794",
  null
  
)

export default component.exports